import React from "react";
import { IndexedConsultation } from "..";
import { DayProps } from "../../Day";
import ExaminationSelect from "./ExaminationSelect";
import { InputsMainWrapper } from "./InputStyles";
import RoomSelect from "./RoomSelect";
import TimeSelector from "./TimeSelector";

interface Props {
    consultation: IndexedConsultation;
    day: DayProps;
}

export interface CommonInputProps {
    day: DayProps;
    consultationIndex: number;
    isClickOnTop?: boolean;
}

const ConsultationInputs = ({ consultation, day }: Props) => {
    const { start, end, room_id, specialization_id } = consultation;

    return (
        <InputsMainWrapper>
            <TimeSelector
                start={start}
                end={end}
                day={day}
                consultationIndex={consultation.index}
            />
            <ExaminationSelect
                specIds={specialization_id}
                day={day}
                consultationIndex={consultation.index}
            />
            <RoomSelect
                roomId={room_id ? parseInt(room_id) : -1}
                day={day}
                consultationIndex={consultation.index}
            />
        </InputsMainWrapper>
    );
};

export default React.memo(ConsultationInputs);
